import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import api, { apiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Logo } from "@/components/Logo";
import { TwoFactorChallenge } from "@/components/TwoFactorChallenge";

export default function AuthCallback() {
  const { loginWithData } = useAuth();
  const nav = useNavigate();
  const processed = useRef(false);
  const [challenge, setChallenge] = useState(null);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;
    if (!sessionId) {
      nav("/login", { replace: true });
      return;
    }

    (async () => {
      try {
        const { data } = await api.post("/auth/google/session", { session_id: sessionId });
        window.history.replaceState({}, document.title, "/app");
        if (data.requires_2fa) { setChallenge(data.challenge_token); return; }
        loginWithData(data);
        toast.success("Signed in with Google.");
        nav("/app", { replace: true });
      } catch (err) {
        toast.error(apiError(err.response?.data?.detail) || "Google sign-in failed.");
        nav("/login", { replace: true });
      }
    })();
  }, [loginWithData, nav]);

  if (challenge) {
    return (
      <div className="min-h-screen grid place-items-center bg-background px-6">
        <div className="w-full max-w-sm">
          <TwoFactorChallenge challengeToken={challenge} onSuccess={(data) => { loginWithData(data); toast.success("Signed in."); nav("/app", { replace: true }); }} />
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen grid place-items-center bg-background">
      <div className="text-center">
        <Logo className="justify-center mb-6" />
        <Loader2 className="w-6 h-6 animate-spin text-brand mx-auto" />
        <p className="text-sm text-muted-foreground mt-3">Completing secure sign-in…</p>
      </div>
    </div>
  );
}
